import { CLICK_PORTAL_SEARCH_FILTERS } from 'consts';
import { SchoolFilters, ClickPortalResultRowsSectionProps } from 'types';

type ResultRow = ClickPortalResultRowsSectionProps['resultRowsConfig'][number];

/**
 * Transforms an array of ResultRow configurations into SchoolFilters array.
 * Filters out rows where all fields (filterKey, subject, concentration, degree) are empty.
 *
 * @param resultRowsConfig - Array of result row configurations to transform
 * @returns Array of SchoolFilters, excluding rows with all empty fields
 */
export function transformResultRowsConfigToSchoolFilters(
    resultRowsConfig: ResultRow[]
): SchoolFilters[] {
    return resultRowsConfig.reduce((acc, row) => {
        // Set values and filter out rows where all fields are missing/empty
        const filterKey = row.filterKey?.trim() || '';
        const subject = row.filters?.parentCategory?.trim() || '';
        const concentration = row.filters?.category?.trim() || '';
        const degree = row.filters?.degreeType?.trim() || '';

        // Remove row if nothing is set
        if (!filterKey && !subject && !concentration && !degree) {
            return acc;
        }

        // Transform and add valid rows
        acc.push({
            [CLICK_PORTAL_SEARCH_FILTERS.FILTER_KEY]: filterKey,
            [CLICK_PORTAL_SEARCH_FILTERS.SUBJECTS]: {
                value: subject,
            },
            [CLICK_PORTAL_SEARCH_FILTERS.CONCENTRATIONS]: {
                value: concentration,
            },
            [CLICK_PORTAL_SEARCH_FILTERS.DEGREES]: {
                value: degree,
            },
        });

        return acc;
    }, [] as SchoolFilters[]);
}

